import React from 'react';
import { IMFormModal, IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { InboundLeadModalStore } from 'store/ui-stores/dashboard/inboundLeadModalStore';
import { INBOUND_LEAD_FORM_ID } from '../constants';

interface Props {
  modalStore: InboundLeadModalStore;
}

const InboundLeadModal: React.FC<Props> = observer(({ modalStore }) => {
  const { formController, agentsOfRecord, modalDelegate } = modalStore;

  return (
    <IMFormModal
      formId={INBOUND_LEAD_FORM_ID}
      title="Group Info"
      subtitle="Set Agent of Record"
      show={modalDelegate.isVisible}
      onClose={modalDelegate.close}
      formController={formController}
      closeButtonText="Close"
      submitButtonText="Save and continue"
      formContent={
        <>
          <IMInputText label="Group Name" name="groupName" $size="full" disabled />
          <IMSelect
            label="Agents of Record"
            name="agentOfRecordId"
            placeholder="Select an agent"
            options={agentsOfRecord}
            $size="full"
          />
        </>
      }
    />
  );
});

export default InboundLeadModal;
